import React from 'react';
import { Box, TextField } from '@mui/material';

interface DateSelectorProps {
    selectedDate: string;
    onDateChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({
    selectedDate,
    onDateChange
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: '250px' }}>
            <TextField
                label="Выберите дату"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={selectedDate}
                onChange={onDateChange}
                size="small"
                sx={{
                    width: '230px',
                }}
            />
        </Box>
    );
};

export default DateSelector;
